import { render } from "./loginOrRegister.vue?vue&type=template&id=1d4821ee&scoped=true"
import script from "./loginOrRegister.vue?vue&type=script&lang=js"
export * from "./loginOrRegister.vue?vue&type=script&lang=js"

import "./loginOrRegister.vue?vue&type=style&index=0&id=1d4821ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4821ee"]])

export default __exports__